"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Loading Spinner
// ===============
var Spinner = function Spinner(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      className = _ref.className,
      isSeasonal = _ref.isSeasonal;
  return type === 'default' ? /*#__PURE__*/_react.default.createElement(SpinnerDefault, {
    className: className,
    isSeasonal: isSeasonal
  }) : /*#__PURE__*/_react.default.createElement(SpinnerLarge, {
    className: className,
    isSeasonal: isSeasonal
  });
};

Spinner.propTypes = {
  type: _propTypes.default.oneOf(['default', 'large'])
};

var SpinnerDefault = function SpinnerDefault(_ref2) {
  var className = _ref2.className,
      isSeasonal = _ref2.isSeasonal;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (0, _classnames.default)(_indexModule.default.SpinnerDefault, (0, _defineProperty2.default)({}, _indexModule.default.SpinnerSeasonal, isSeasonal), className),
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5,28.5 C23.127417,28.5 28.5,23.127417 28.5,16.5 C28.5,9.872583 23.127417,4.5 16.5,4.5 C9.872583,4.5 4.5,9.872583 4.5,16.5 C4.5, 17.3284271 5.17157288,18 6,18 C6.82842712,18 7.5,17.3284271 7.5,16.5 C7.5,11.5294373 11.5294373,7.5 16.5,7.5 C21.4705627,7.5 25.5,11.5294373 25.5,16.5 C25.5,21.4705627 21.4705627,25.5 16.5,25.5 C15.6715729,25.5 15,26.1715729 15,27 C15,27.8284271 15.6715729,28.5 16.5,28.5 Z"
  })));
};

SpinnerDefault.propTypes = {
  className: _propTypes.default.string,
  isSeasonal: _propTypes.default.bool
};

var SpinnerLarge = function SpinnerLarge(_ref3) {
  var className = _ref3.className,
      isSeasonal = _ref3.isSeasonal;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_indexModule.default.SpinnerLarge, (0, _defineProperty2.default)({}, _indexModule.default.SpinnerSeasonal, isSeasonal), className)
  });
};

SpinnerLarge.propTypes = {
  className: _propTypes.default.string,
  isSeasonal: _propTypes.default.bool
};
var _default = Spinner;
exports.default = _default;